// import { Observer } from 'mobx-react';
import React from 'react';
import { BaseModal } from '../../../../../../common/components/BaseModal/BaseModal';
import { PrimaryButton } from '../../../../../../common/components/buttons/NewButtons.styles';
import { VipPendingModalContent, VipPendingModalFooter, VipPendingModalHeader, VipPendingModalHeaderText, VipPendingModalWrapper } from '../../../AddItem.styles';
import {VipSyncStatusCard} from '../../../../../wealth/pages/asset/components/VipSyncing/VipSyncStatusCard';

export const VipPendingModal = (props) => {
  const { onDone , item , isActivationFlow } = props;
  
  return (
    <BaseModal width={'550px'} height={'auto'} borderRadius={8} noSidebarMargin={isActivationFlow} >
      <VipPendingModalWrapper>

      <VipPendingModalHeader>
        <VipPendingModalHeaderText>{item.vipAccessRequirement !== 'manual' ? 'VIP Syncing request in progress...' : 'VIP Syncing Service'}</VipPendingModalHeaderText>
      </VipPendingModalHeader>
      <VipPendingModalContent>
      <VipSyncStatusCard institutionName={item.name} status={'pending'} is3rdParty={item.vipAccessRequirement !== 'manual'} marginTop='0px'  isAfterCreationModal={true}/>
      </VipPendingModalContent>

      <VipPendingModalFooter>
      <PrimaryButton style={{ borderRadius: '30px', width: '174px', height: '44px'  }} onClick={onDone}>Got it 🎉 </PrimaryButton>
      </VipPendingModalFooter>
      </VipPendingModalWrapper>
    </BaseModal>
  )
}



    